
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/eventi/[slug]/servizi/le-camere",
      function () {
        return require("private-next-pages/stores/eventi/[slug]/servizi/le-camere.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/eventi/[slug]/servizi/le-camere"])
      });
    }
  